import { CARD_TYPE, Card, GetCardsParams } from "@letsbit/malcolmlb";
import { useContext } from "react";
import { SWRResponse } from "swr";

import { ApiContext } from "providers/ApiProvider";
import { useAuthSWR } from "hooks/utils/useAuthSWR";

export enum CARD_COLORS {
  CLASSIC = "classic",
  PINK = "pink",
  GOLD = "gold",
  LAVANDER = "lavander",
  BLACK = "black",
  SILVER = "silver",
}

export const SWR_GET_CARDS = "get-cards";

export const stringToColorCard = (
  card_id: string,
  color?: string,
): CARD_COLORS => {
  const colorList = Object.values(CARD_COLORS).filter(
    (c) => c !== CARD_COLORS.BLACK,
  );

  switch (color) {
    case CARD_COLORS.BLACK:
      return CARD_COLORS.BLACK;
    case CARD_COLORS.CLASSIC:
      return CARD_COLORS.CLASSIC;
    case CARD_COLORS.GOLD:
      return CARD_COLORS.GOLD;
    case CARD_COLORS.LAVANDER:
      return CARD_COLORS.LAVANDER;
    case CARD_COLORS.PINK:
      return CARD_COLORS.PINK;
    case CARD_COLORS.SILVER:
      return CARD_COLORS.SILVER;
    default:
      // eslint-disable-next-line no-case-declarations
      let hash = 0;

      for (let i = 0; i < card_id.length; i++) {
        hash = card_id.charCodeAt(i) + hash * Math.pow(2, 5);
      }
      return colorList[hash % colorList.length];
  }
};

export const useGetCards = (
  params?: GetCardsParams,
): SWRResponse<Card[], Error> => {
  const { memberInstance } = useContext(ApiContext);
  const swr = useAuthSWR(
    [SWR_GET_CARDS, params],
    async () => {
      const { data: cards } = await memberInstance.kaibacorp.getCards(params);

      const physicalCards = cards.filter(
        (card) => card.card_type.type === CARD_TYPE.PHYSICAL,
      );
      const otherCards = cards.filter(
        (card) => card.card_type.type !== CARD_TYPE.PHYSICAL,
      );

      return [...physicalCards, ...otherCards];
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return swr;
};
